import { AppointmentState, ProviderMedicalRole } from '@uplift/types';

export enum AppointmentType {
  psychiatry = 'psychiatry',
  therapy = 'therapy',
}

export enum AppointmentRecurring {
  biweekly = 'biweekly',
  monthly = 'monthly',
  none = 'none',
  weekly = 'weekly',
}

export enum AppointmentSlotDuration {
  fifteen = 'fifteen',
  twenty = 'twenty',
  forty_five = 'forty_five',
  sixty = 'sixty',
  thirty = 'thirty',
}

export const SlotStepByMedicalRole: Record<ProviderMedicalRole, number> = {
  [ProviderMedicalRole.therapist]: 15,
  [ProviderMedicalRole.psychiatrist]: 5,
};

export enum ServiceType {
  audio_and_video = 'audio_and_video',
  in_person = 'in_person',
}

export enum PsychAppointmentBookingSource {
  providerClientMedicalRecord = 'provider_medical_record',
  providerInSession = 'provider_in-session',
  clientTodoGad7 = 'client_todo_gad7',
  clientTodoPhq9 = 'client_todo_phq9',
  clientTodoPhq9Gad7 = 'client_todo_phq9_gad7',
  clientReviewGad7 = 'client_form_gad7',
  clientReviewPhq9 = 'client_form_phq9',
  clientUpliftStandard = 'client_uplift_standard',
  referralEmail = 'referral_email',
}

type PsychAppointmentBookingSourceKeys = keyof typeof PsychAppointmentBookingSource;
export const PsychAppointmentBookingSourceFromString = Object
  .keys(PsychAppointmentBookingSource)
  .reduce<Record<string, PsychAppointmentBookingSource | undefined>>(
    (prev, curr) => ({
      ...prev,
      [PsychAppointmentBookingSource[curr as PsychAppointmentBookingSourceKeys]]: PsychAppointmentBookingSource[curr as PsychAppointmentBookingSourceKeys],
    }),
    {}
  );

export type Appointment = {
  id: string;
  fromDatetime: string;
  toDatetime: string;
  state: AppointmentState;
  recurring?: AppointmentRecurring;
  type: AppointmentType;
  patientId: string;
  providerId: string;
  appointmentSeriesId?: string;
  createdBy?: string;
  chargeFee?: boolean;
  cancelReason?: string;
  createdAt: string;
  cancelledAt?: string;
  isMaterialized: boolean;

  twilioMeta?: string;
};
// todo: add remaining properties


export type LegacyUICalendarEventAppointment = {
  id: string;
  type: AppointmentType;
  created_at: string;
  from_datetime: string;
  from_datetime_without_tz: string;
  appointment_series_id?: string;
  patient_id: string;
  provider_id: string;
  recurring?: AppointmentRecurring;
  state: AppointmentState;
  timezone: string;
  to_datetime: string;
  to_datetime_without_tz: string;
  is_materialized: boolean;
  charge_fee?: boolean;
};
